<template>
  <PageTitle :title="content.artWorks" :parentTitle="content.home">
    <div class="flex items-center">
      <div
        class="
          bg-primary
          relative
          
          h-16
          lg:min-w-[240px]
          min-w-[160px]
          sm:min-w-[200px]
          
          px-4
          flex
          items-center
          justify-between
          cursor-pointer
        "
        :class="{'ltr:mr-4 rtl:ml-4':type!='collections'}"
        @click="openFilter = !openFilter"
      >
        <div class="capitalize ltr:mr-2 rtl:ml-2 text-sm sm:text-base">
          {{ content[$route.query.type] }}
        </div>
        <div>
          <i
            class="fa fa-chevron-down transition-all duration-300"
            :class="{ 'rotate-180': openFilter }"
          ></i>
        </div>
        <div
          class="
            max-h-0
            
            overflow-hidden
            lg:min-w-[240px]
            min-w-[160px]
            sm:min-w-[200px]
            transition-all
            duration-300
            absolute
            left-0
            top-[74px]
            z-[1]
            bg-primary
          "
          :class="{ openWorksFilter: openFilter }"
        >
          <router-link
            to="/works?type=allArtWorks"
            v-if="$route.query.type != 'allArtWorks'"
          >
            <div
              class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              "
            >
              {{ content.allArtWorks }}
            </div>
          </router-link>
          <router-link
            to="/works?type=collections"
            v-if="$route.query.type != 'collections'"
          >
            <div
              class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              "
            >
              {{ content.collections }}
            </div>
          </router-link>
          <router-link
            to="/works?type=paintings"
            v-if="$route.query.type != 'paintings'"
          >
            <div
              class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              "
            >
              {{ content.paintings }}
            </div>
          </router-link>
          <router-link
            to="/works?type=drawings"
            v-if="$route.query.type != 'drawings'"
          >
            <div
              class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              "
            >
              {{ content.drawings }}
            </div>
          </router-link>
          <router-link
            to="/works?type=stones"
            v-if="$route.query.type != 'stones'"
          >
            <div
              class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              "
            >
              {{ content.stones }}
            </div>
          </router-link>
          <router-link
            to="/works?type=unfinishedworks"
            v-if="$route.query.type != 'unfinishedworks'"
          >
            <div
              class="
                capitalize
                text-sm
                sm:text-base
                px-4
                flex
                items-center
                h-16
                hover:bg-secondary
                transition-all
                duration-200
                cursor-pointer
              "
            >
              {{ content.unfinishedworks }}
            </div>
          </router-link>
        </div>
      </div>
      <YearDropdown @setYear="setYear" v-show="type != 'collections'"></YearDropdown>
    </div>
  </PageTitle>
  <div v-if="noResult && type != 'collections'" class="font-xl layout-padding">
    {{ content.noResultFound }}
  </div>
  <ItemsSkeleton v-else-if="works.length == 0 && type != 'collections'" />

  <div v-else-if="works?.length != 0 && type != 'collections'">
    <div
      class="
        grid grid-cols-6
        layout-padding
        lg:gap-x-32
        md:gap-x-16
        gap-x-0 gap-y-5
      "
    >
      <div
        class="col-span-6 md:col-span-3 lg:col-span-2 animate-painting"
        v-for="(work, index) in works"
        :key="index"
        :class="
          index % 2 == 0
            ? `lg:mt-14 even animate-painting-${index}`
            : `odd lg:mt-5 animate-painting-odd-${index}`
        "
      >
        <PaintingCard
          :work="work"
          :collectionTitle="work?.collection?.title"
          :collectionYear="work?.collection?.year"
        />
      </div>
      <div class="col-span-6 flex justify-center my-8">
        <div
          @click="loadData"
          v-if="!allWorksLoaded"
          class="
            py-4
            px-10
            bg-primary
            w-max
            text-center
            transition-all
            duration-700
            hover:bg-secondary
            cursor-pointer
            min-w-[216px]
          "
        >
          {{ content.loadMore }}
        </div>
      </div>
    </div>
  </div>

  <ItemsSkeleton v-if="collections.length == 0 && type == 'collections'" />
  <div v-else-if="collections?.length != 0 && type == 'collections'">
    <div
      class="
        grid grid-cols-6
        layout-padding
        lg:gap-x-32
        md:gap-x-16
        gap-x-0 gap-y-5
      "
    >
      <div
        class="col-span-6 md:col-span-3 lg:col-span-2 animate-collection"
        v-for="(collection, index) in collections?.data"
        :key="index"
        :class="
          index % 2 == 0
            ? `lg:mt-14 even animate-collection-${index}`
            : `odd lg:mt-5 animate-collection-odd-${index}`
        "
      >
        <CollectionCard :collection="collection" />
      </div>
      <div class="col-span-6 flex justify-center my-8">
        <div
          @click="loadData"
          v-if="!allWorksLoaded"
          class="
            py-4
            px-10
            bg-primary
            w-max
            text-center
            transition-all
            duration-700
            hover:bg-secondary
            cursor-pointer
            min-w-[216px]
          "
        >
          {{ content.loadMore }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import PaintingCard from "/src/components/UI/Cards/PaintingCard.vue";
import CollectionCard from "/src/components/UI/Cards/CollectionCard.vue";
export default {
  inject: ["content"],
  data() {
    return {
      openFilter: false,
      selectedYear: null,
      oldLength: 0,
    };
  },
  computed: {
    works() {
      return this.$store.getters["works/works"];
    },
    noResult() {
      return this.$store.getters["works/noResult"];
    },
    type() {
      return this.$route.query.type;
    },
    collections() {
      return this.$store.getters["collections/collections"];
    },
    allWorksLoaded() {
      return this.$store.getters["works/allWorksLoaded"];
    },
  },
  components: {
    PaintingCard,
    CollectionCard,
  },
  methods: {
    async loadData() {
      if (this.allWorksLoaded == false) {
        this.oldLength = this.works.length;
        if (this.$route.query.type != "allArtWorks") {
          await this.$store.dispatch("works/filterWorks", {
            type: this.$route.query.type,
            year: this.selectedYear == null ? "all" : this.selectedYear,
          });
          await this.animate();
        } else {
          await this.$store.dispatch("works/filterWorks", {
            type: "all",
            year: this.selectedYear == null ? "all" : this.selectedYear,
          });
          await this.animate();
        }
      }
    },
    setYear(year) {
      this.selectedYear = year;
    },
    animate() {
      if (screen.width > 1024 || screen.width < 768) {
        for (let s = this.oldLength; s < this.works.length; s++) {
          gsap.to(`.animate-painting-${s}`, {
            y: "-30%",
            scrollTrigger: {
              trigger: `.animate-painting-${s}`,
              start: "top 200",
              end: "500",
              scrub: 1,
            },
          });
          gsap.to(`.animate-painting-odd-${s}`, {
            y: "-15%",
            scrollTrigger: {
              trigger: `.animate-painting-odd-${s}`,
              start: "top top",
              end: "500",
              scrub: 1,
            },
          });
        }
      } else {
        for (let s = this.oldLength; s < this.works.length; s++) {
          gsap.to(`.animate-painting-${s}`, {
            y: "-15%",
            scrollTrigger: {
              trigger: `.animate-painting-${s}`,
              start: "top 200",
              end: "500",
              scrub: 1,
            },
          });
          gsap.to(`.animate-painting-odd-${s}`, {
            y: "-15%",
            scrollTrigger: {
              trigger: `.animate-painting-odd-${s}`,
              start: "top 200",
              end: "500",
              scrub: 1,
            },
          });
        }
      }
    },
  },
  watch: {
    "$route.query.type": {
      handler: function () {
        this.$store.dispatch("works/resetWorks");
        this.oldLength = 0;
        this.loadData();
      },
      deep: true,
      immediate: true,
    },
    selectedYear() {
      this.$store.dispatch("works/resetWorks");
      this.loadData();
    },
    collections() {
      if (this.collections?.data?.length > 0) {
        setTimeout(() => {
          if (screen.width > 1024 || screen.width < 768) {
            for (let s = 0; s < this.collections?.data?.length; s++) {
              gsap.to(`.animate-collection-${s}`, {
                y: "-30%",
                scrollTrigger: {
                  trigger: `.animate-collection-${s}`,
                  start: "top 200",
                  end: "500",
                  scrub: 1,
                },
              });
              gsap.to(`.animate-collection-odd-${s}`, {
                y: "-15%",
                scrollTrigger: {
                  trigger: `.animate-collection-odd-${s}`,
                  start: "top top",
                  end: "500",
                  scrub: 1,
                },
              });
            }
          } else {
            for (let s = 0; s < this.collections?.data?.length; s++) {
              gsap.to(`.animate-collection-${s}`, {
                y: "-15%",
                scrollTrigger: {
                  trigger: `.animate-collection-${s}`,
                  start: "top 200",
                  end: "500",
                  scrub: 1,
                },
              });
              gsap.to(`.animate-collection-odd-${s}`, {
                y: "-15%",
                scrollTrigger: {
                  trigger: `.animate-collection-odd-${s}`,
                  start: "top 200",
                  end: "500",
                  scrub: 1,
                },
              });
            }
          }
        }, 200);
      }
    },
  },
  mounted() {
    this.$store.dispatch("collections/collections");
  },
};
</script>